"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PossessedEffectHandler = exports.PossessedEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class PossessedEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Possessed;
        this.__typeName = "Possessed";
        this.name = "Possessed";
        this.harmful = true;
    }
}
exports.PossessedEffectArgs = PossessedEffectArgs;
let PossessedEffectHandler = class PossessedEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            effectCreatorId: state.creatorId
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CustomScriptEventHandlerArgs("Effect_Possessed_OnKilled", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
PossessedEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Possessed)
], PossessedEffectHandler);
exports.PossessedEffectHandler = PossessedEffectHandler;
